export const Setup ={
    endpoint:process.env.REACT_APP_API_ENDPOINT,
    payment_endpoint:process.env.REACT_APP_API_PAYMENT_ENDPOINT,
    version:process.env.REACT_APP_API_VERSION,
    default_malls:"ww8Sa3xrPp",
    default_merchant:"mhnQDWQe8j",
    mqtt:process.env.REACT_APP_MQTT,

}
